export default "__VITE_ASSET__bdfc60ca__"